import React from "react";
import { Tab, Segment, Header } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TeamDetails from "./TeamDetails";

const TeamDashboard = () => {
    const panes = [
        {
            menuItem: "Finnigan's Harp I",
            render: () => <TeamDetails id={1} />,
        },
        {
            menuItem: "Finnigan's Harp II",
            render: () => <TeamDetails id={2} />,
        },
        {
            menuItem: "Finnigan's Harp III",
            render: () => <TeamDetails id={3} />,
        },
        {
            menuItem: "Finnigan's Harp IV",
            render: () => <TeamDetails id={4} />,
        },
        {
            menuItem: "Finnigan's Harp V",
            render: () => <TeamDetails id={5} />,
        },
        {
            menuItem: "Finnigan's Harp VI",
            render: () => <TeamDetails id={6} />,
        },
        {
            menuItem: "Finnigan's Harp VII",
            render: () => <TeamDetails id={7} />,
        }, 
        {
            menuItem: "Finnigan's Harp VIII",
            render: () => <TeamDetails id={8} />,
        },
    ];

    return (
        <Segment>
            <Header as="h2" className="homeHeader">Unsere Mannschaften</Header>
            <Tab menu={{ pointing: true, stackable: true, className: "teams-scroll" }} panes={panes} />
        </Segment>
    );
};

export default observer(TeamDashboard);